import React, { useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import ModalToOpenEditJobs from "../../ModalToOpenEditJobs";
import {
  Accordion,
  AccordionDetails,
  Grid,
  Box,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  IconButton,
  Menu,
  MenuItem,
  Modal,
  Typography,
  Button,
  TextField,
  Checkbox,
} from "@mui/material";
import styles from "../../JobBatch.module.css";
import MoreVertIcon from "@mui/icons-material/MoreVert";

const AvailableJobs = ({
  updateJobInParent,
  availableJobs,
  selectedJobs,
  selectAll,
  setSelectAll,
  setSelectedJobs,
  service,
}) => {
  const [searchTermProduct, setSearchTermProduct] = useState("");
  const [searchTermCity, setSearchTermCity] = useState("");
  const [searchTermState, setSearchTermState] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedJob, setSelectedJob] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const { id } = useParams();

  const handleSelectJob = (job) => {
    setSelectedJobs((prevSelected) => {
      const isAlreadySelected = prevSelected.find(
        (item) => item._id === job._id,
      );

      if (isAlreadySelected) {
        return prevSelected.filter((item) => item._id !== job._id);
      } else {
        return [...prevSelected, job];
      }
    });
  };
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedJobs(filteredJobs); // Directly store all job objects
      setSelectAll(true);
    } else {
      setSelectedJobs([]);
      setSelectAll(false);
    }
  };
  const handleMenuClick = (event, job) => {
    setAnchorEl(event.currentTarget);
    setSelectedJob(job);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleEditJob = () => {
    setOpenModal(true);
    handleCloseMenu();
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const updateJob = async (job) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.put(
        `${process.env.REACT_APP_URL}/jobs/updateJob/${job._id}`,
        job,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      return response.data.data; // Return the updated job data
    } catch (error) {
      console.error("Error updating job:", error);
      return null;
    }
  };

  const handleSaveJob = async (updatedFields) => {
    if (!selectedJob || !selectedJob._id) {
      console.error("Selected job does not have an id");
      return;
    }

    const updatedJob = await updateJob(updatedFields);
    if (updatedJob) {
      updateJobInParent(updatedJob); // Update the parent state
      handleCloseModal();
    }
  };

  const filteredJobs = availableJobs.filter((job) => {
    const matchesProduct = searchTermProduct.trim()
      ? job?.product?.productType
          ?.toLowerCase()
          .includes(searchTermProduct.toLowerCase())
      : true;
    const matchesCity = searchTermCity.trim()
      ? job.city?.toLowerCase().includes(searchTermCity.toLowerCase())
      : true;
    const matchesState = searchTermState.trim()
      ? job.state?.toLowerCase().includes(searchTermState.toLowerCase())
      : true;
    return matchesProduct && matchesCity && matchesState;
  });

  return (
    <Grid item xs={12} md={12} my={1} mx={2}>
      {/* Show Total Job Count */}
      {/* <p className={styles.totalJobsText}>Total Jobs Available: {availableJobs.length}</p> */}

      <div className="flex justify-start items-center my-2">
        <input
          type="text"
          placeholder="Search product"
          value={searchTermProduct}
          onChange={(e) => setSearchTermProduct(e.target.value)}
          className={`${styles.searchInput}`}
        />
        <input
          type="text"
          placeholder="Search city"
          value={searchTermCity}
          onChange={(e) => setSearchTermCity(e.target.value)}
          className={`${styles.searchInput}`}
        />
        <input
          type="text"
          placeholder="Search state"
          value={searchTermState}
          onChange={(e) => setSearchTermState(e.target.value)}
          className={`${styles.searchInput}`}
        />
        {filteredJobs.length > 0 && (
          <Box ml={1}>
            <strong>{filteredJobs.length}</strong> job
            {filteredJobs.length > 1 ? "s" : ""} found
          </Box>
        )}
      </div>
      {/* Check if availableJobs is empty */}
      {filteredJobs.length === 0 ? (
        <div className={styles.noJobsStyle}>
          <Box className={styles.noJobsBox}>
            <p className={styles.noJobsText}>No jobs are available</p>
          </Box>
        </div>
      ) : (
        <Accordion>
          <AccordionDetails className={styles.accordionDetails}>
            <Box className={`${styles.scrollableBox}`}>
              <TableContainer
                component={Paper}
                className={styles.tableContainer}
              >
                <Table className={styles.table}>
                  <TableHead>
                    <TableRow className={styles.tableHeader}>
                      <TableCell
                        padding="checkbox"
                        className={styles.tableCell}
                      >
                        <Checkbox
                          checked={selectAll}
                          onChange={handleSelectAll}
                          className={styles.checkbox}
                        />
                      </TableCell>
                      <TableCell className={styles.tableCell}>
                        PRODUCT TYPE
                      </TableCell>
                      <TableCell className={styles.tableCell}>CITY</TableCell>
                      <TableCell className={styles.tableCell}>
                        ADDRESS
                      </TableCell>
                      <TableCell className={styles.tableCell}>
                        STORE NAME
                      </TableCell>
                      <TableCell className={styles.tableCell}>
                        STORE MANAGER
                      </TableCell>
                      <TableCell className={styles.tableCell}>
                        STORE MANAGER NUMBER
                      </TableCell>

                      <TableCell className={styles.tableCell}>ACTION</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredJobs?.map((row, index) => (
                      <TableRow key={index} className={styles.customRow}>
                        <TableCell
                          padding="checkbox"
                          className={styles.tableCell}
                        >
                          <Checkbox
                            checked={selectedJobs?.some(
                              (item) => item._id === row._id,
                            )}
                            onChange={() => handleSelectJob(row)}
                            className={styles.checkbox}
                          />
                        </TableCell>
                        <TableCell className={styles.tableCell}>
                          <div className={styles.sharedTextStyle}>
                            {row?.product?.productType}
                          </div>
                        </TableCell>
                        <TableCell className={styles.tableCell}>
                          <div className={styles.sharedTextStyle}>
                            {row.city}
                          </div>
                        </TableCell>

                        <TableCell className={styles.tableCell}>
                          <div className={styles.sharedTextStyle}>
                            {row.address}
                          </div>
                          <div className={styles.address2}>
                            {row.city}, {row.state}, {row.zipCode}
                          </div>
                        </TableCell>
                        <TableCell className={styles.tableCell}>
                          <div className={styles.sharedTextStyle}>
                            {row.storeName}
                          </div>
                        </TableCell>
                        <TableCell className={styles.tableCell}>
                          <div className={styles.sharedTextStyle}>
                            {row.storeOwnerName}
                          </div>
                          <div>{row.storeManagerContact}</div>
                        </TableCell>
                        <TableCell className={styles.tableCell}>
                          <div className={styles.sharedTextStyle}>
                            {row.storeOwnerPhoneNumber}
                          </div>
                        </TableCell>

                        {/* <TableCell className={styles.tableCell}>
                          <div className={styles.sharedTextStyle}>
                            {row.jobStartingDate || '- -'}
                          </div>
                        </TableCell> */}
                        <TableCell className={styles.tableCell}>
                          {row.status != 2 && (
                            <IconButton
                              onClick={(event) => handleMenuClick(event, row)}
                            >
                              <MoreVertIcon />
                            </IconButton>
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </AccordionDetails>
        </Accordion>
      )}

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuItem onClick={handleEditJob}>Edit Job</MenuItem>
        
      </Menu>
      <ModalToOpenEditJobs
        open={openModal}
        handleClose={handleCloseModal}
        selectedJob={selectedJob}
        setSelectedJob={setSelectedJob}
        handleSaveJob={handleSaveJob}
        showJobPayField={false}
        service={service}
      />
    </Grid>
  );
};

export default AvailableJobs;
